import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaVoteYea, FaChartBar, FaUserShield, FaMobileAlt } from 'react-icons/fa';
import './Feature.css';

const Feature = () => {
  const features = [
    {
        icon: <FaUserShield className="feature-icon" />,
        title: "憑證管理",
        description: "供帳號憑證資訊，有助於更快速有效地管理大量帳號"
      },
    {
      icon: <FaVoteYea className="feature-icon" />,
      title: "電投表列印",
      description: "提供多種列印格式，方便您快速列印電投表"
    },
    // {
    //   icon: <FaChartBar className="feature-icon" />,
    //   title: "Real-time Results",
    //   description: "Watch results update in real-time as votes come in. Get instant insights with our dynamic visualization tools."
    // },
    // {
    //   icon: <FaMobileAlt className="feature-icon" />,
    //   title: "Mobile Friendly",
    //   description: "Access EzVote from any device. Our responsive design works seamlessly on desktop, tablet, and mobile."
    // }
  ];

  return (
    <Container className="feature-page py-5">
      <h1 className="text-center mb-5">EzVote</h1>
      {/* Gradient Card Section */}
      <div className="gradient-card mb-5">
        <div className="gradient-card-content">
          <div className="gradient-card-text">
            <h2 className="gradient-card-title">自動投票</h2>
            <p className="gradient-card-desc">
              強大的自動投票功能，面對每年高達700場股東會，您可以輕鬆完成投票。
            </p>
            <button className="download-button">下載</button>
          </div>
          <div className="gradient-card-img">
            <img src={process.env.PUBLIC_URL + '/ezvote_pic1.jpg'} alt="EzVote 功能示意圖" />
          </div>
        </div>
      </div>
      {/* End Gradient Card Section */}
      <Row className="g-4">
        {features.map((feature, index) => (
          <Col key={index} md={6}>
            <Card className="h-100 feature-card">
              <Card.Body className="text-center">
                <div className="feature-icon-container mb-3">
                  {feature.icon}
                </div>
                <Card.Title>{feature.title}</Card.Title>
                <Card.Text>{feature.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Feature; 